import { render } from "./AddOrEditHospital.vue?vue&type=template&id=6dbb90ca&scoped=true"
import script from "./AddOrEditHospital.vue?vue&type=script&lang=js"
export * from "./AddOrEditHospital.vue?vue&type=script&lang=js"

import "./AddOrEditHospital.vue?vue&type=style&index=0&id=6dbb90ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbb90ca"]])

export default __exports__